import ChatMarkdown from "@/components/ui/chat/ChatMarkdown";
import {
  type ReportTextStyle,
  resolveReportTextStyle,
} from "@/components/ui/report/reportPresentation";
import { cn } from "@/lib/utils";

interface ReportMarkdownProps {
  children: string;
  textStyle?: ReportTextStyle | null;
  className?: string;
}

/** Markdown body copy that inherits authored report typography. */
export const ReportMarkdown = ({
  children,
  textStyle,
  className,
}: ReportMarkdownProps) => (
  <div
    className={cn("m-0 text-xs leading-relaxed text-gray-900", className)}
    style={resolveReportTextStyle(textStyle)}
  >
    {/* Email CSS lowering raises Typography specificity; these overrides must still win. */}
    <ChatMarkdown className="[font-size:inherit] [line-height:inherit] text-inherit [&_p]:m-0 [&_p]:leading-[inherit] [&_strong]:text-inherit [&_a]:text-blue-600! [&_a]:decoration-current! [&_code]:bg-transparent! [&_code]:text-inherit! [&_code]:[font-size:inherit]! [&_pre]:bg-transparent! [&_pre]:border-0! [&_pre]:text-inherit! [&_pre]:[font-size:inherit]!">
      {children}
    </ChatMarkdown>
  </div>
);
